import React from 'react'

import cn from '../../libs/class-names'

import ToggleField from '../toggle-field'

export interface Props {
  classNames?: string[]
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}

const FilterToggle = ({classNames, label, checked, onChange}: Props) => (
  <div className={cn('FilterToggle', {checked}, classNames)}>
    <ToggleField checked={checked} onChange={onChange} invert />
    <div className="FilterToggle__label">{label}</div>
  </div>
)

export default FilterToggle
